<template>
    <div>
        <b-form-input class="border-0 pl-2"
                      placeholder="Untitled Report"
                      size="lg"
                      type="text"
                      v-model="report.title"/>
        <b-navbar class="report-nav p-0 pl-1" toggleable="lg">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse id="nav_dropdown_collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item-dropdown left text="Report">
                        <b-dropdown-item @click="save">Save</b-dropdown-item>
                        <b-dropdown-item v-if="report_id" @click="newReport()">New</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown right text="Widgets">
                        <b-dropdown-item @click="addText">Text</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item @click="showShareModal('Share')">
                        <font-awesome-icon icon="share-square"/>
                        Share
                    </b-nav-item>
                    <b-nav-item @click="showShareModal('Embed')">
                        <font-awesome-icon icon="code"/>
                        Embed
                    </b-nav-item>
                    <b-nav-item @click="setEdit(true)" v-if="!edit">
                        <font-awesome-icon icon="pencil-alt"/>
                        Edit
                    </b-nav-item>
                    <b-nav-item @click="setEdit(false)" v-else>
                        <font-awesome-icon icon="eye"/>
                        View
                    </b-nav-item>
                    <b-nav-item @click="reload()" v-b-tooltip.hover title="Get fresh data">
                        <font-awesome-icon icon="sync-alt"/>
                        Reload
                    </b-nav-item>
                    <div v-if="secretWord">
                        <b-form-input class="border-0 ml-2 pl-0"
                                    size="sm"
                                    type="text"
                                    placeholder="insert your secret word"
                                    v-model="report.secretWord"/>
                    </div>
                </b-navbar-nav>
            </b-collapse>
            <div class="row pull-right mr-2">
                <div v-if="saving"
                    class="mt-3">
                    <tiny-bouncer/>
                </div>
                <div>
                    <toggle-button :labels="{checked: 'Public', unchecked: 'Private'}" :sync="true"
                                :value="status === 'public'"
                                :width="70"
                                @change="onToggleChange"
                                name="toggleButton"
                                style="margin-top: 7px">
                    </toggle-button>
                </div>
            </div>
        </b-navbar>
        <hr class="mb-0">
        <share-modal-component
            ref="myModal"
            :status="status"
            :origin="'report'"
            :id="report_id"
            @show="show()"
            :action="action"
            :base-url="baseUrl">
        </share-modal-component>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import ToggleButton from 'vue-js-toggle-button/src/Button';
    import ShareModalComponent from '../../components/ShareModal.vue';
    import TinyBouncer from '../../components/TinyBouncer';

    export default {
        props: ['report_id'],
        data() {
            return {
                reportUrl: '',
                secretWord: false,
                action: '',
                saving: false
            }
        },
        components: {
            ToggleButton,
            ShareModalComponent,
            TinyBouncer
        },
        computed: {
            ...mapState('reports', {
                status: 'status',
                report: 'report',
                elements: 'elements',
                edit: 'edit',
                parameters: 'parameters',
            }),
            ...mapState({
                baseUrl: state => state.baseUrl,
            })
        },
        methods: {
            ...mapActions('reports', {
                addText: 'addText'
            }),
            onToggleChange(val) {
                let status = 'private';
                if (val.value) {
                    status = 'public';
                }
                this.$store.commit('reports/SET_REPORT_STATUS', status);
                if (this.report_id) {
                    this.save();
                }
            },
            reload() {
                this.$parent.reload();
            },
            save() {
                this.saving = true;
                if (this.report_id) {
                    return this.$store.dispatch('reports/update', this.report_id).then(() => {
                        this.saving = false;
                    });
                } else {
                    return this.$store.dispatch('reports/create').then(() => {
                        this.saving = false;
                    });
                }
            },
            showShareModal(action) {
                if (this.report_id) {
                    this.action = action;
                    this.$refs.myModal.show();
                } else {
                    this.$swal('Save your report first');
                }
            },
            setEdit(boolean) {
                this.$store.commit('reports/SET_EDIT_MODE', boolean);
            },
            parametersList() {
                let list = ''
                if (this.parameters.length !== 0) {
                    list = `?${this.parameters[0].name}=${this.parameters[0].default}`;
                    if (this.parameters.length > 1) {
                        for (let index = 1; index < this.parameters.length; index++) {
                            list = `${list}&${this.parameters[index].name}=${this.parameters[index].default}`;
                        }
                    }
                }
                return list;
            },
            checkType(reportUrl, type) {
                return new Promise(resolve => {
                    if (type === 'parameters') {
                        let parametersList = this.parametersList();
                        this.reportUrl = `${reportUrl}${parametersList}`
                    }
                    resolve();
                })
            },
            newReport() {
                this.$store.commit('visualizations/SET_CHARTDATA_INITIAL_STATE');
                this.$store.commit('visualizations/SET_VISUALIZATION_PARAMETERS', []);
                this.$store.commit('visualizations/SET_PARAMETERS');
                this.$store.dispatch('clearMessages');
                this.$store.dispatch('reports/setInitialStatus').then(() => {
                    this.$router.replace({ name: 'report.create' });
                });
            }
        }
    }
</script>

<style scoped>
</style>
